import { setBaika, setExcelValidation, setFiftyDiscount, setTenDiscount, setThirtyDiscount } from '../../redux/actions/modal';
import { getDeviationRate, getSellingPrice } from './formula';
import { setToastsError } from '../../redux/actions/common';

export const validateFormInput = (dispatch, formData, isFreshness) => {
    if (!formData.expandSalesFloor && !isFreshness) {
        dispatch(setToastsError('売場展開を選択してください。'));
        return true;
    }
    if (!formData.discountedRequestSellingPrice && formData.discountedRequestSellingPrice !== 0) {
        dispatch(setToastsError('売価を入力してください。'));
        return true;
    }
    if (formData.discountedRequestSellingPrice < 1) {
        dispatch(
            setBaika({
                isShow: true,
                items: [formData],
            }),
        );
        return true;
    }
    if (!formData.packingCategory && !isFreshness) {
        dispatch(setToastsError('販売方法・荷姿を選択してください。'));
        return true;
    }
    if (!formData.saleType && !isFreshness) {
        dispatch(setToastsError('特売種別・期間を選択してください。'));
        return true;
    }
    if (!formData.salesStartDate) {
        dispatch(setToastsError('開始日を選択してください。'));
        return true;
    }
    if (!formData.salesEndDate) {
        dispatch(setToastsError('終了日を選択してください。'));
        return true;
    }
    if (!/^\d{4}\/\d{2}\/\d{2}$/.test(formData.salesStartDate)) {
        dispatch(setToastsError('開始日は「yyyy/mm/dd」の形式で入力してください。'));
        return true;
    }
    if (!/^\d{4}\/\d{2}\/\d{2}$/.test(formData.salesEndDate)) {
        dispatch(setToastsError('終了日は「yyyy/mm/dd」の形式で入力してください。'));
        return true;
    }
    if (formData.salesStartDate > formData.salesEndDate) {
        dispatch(setToastsError('終了日は開始日以降を選択してください。'));
        return true;
    }
    if (getDiffDays(formData) > 31) {
        dispatch(setToastsError('終了日は「開始日から31日以内」の日付を入力してください。'));
        return true;
    }
    if (isFreshness && !formData.freshnessReason) {
        dispatch(setToastsError('鮮度起因値下げ理由を入力してください。'));
        return true;
    }
    return false;
};

export const validateExcelInput = (dispatch, formData) => {
    const errors = [];
    formData.forEach((row) => {
        if (!row.expandSalesFloor) {
            errors.push({
                rowNumber: row.id,
                message: '売場展開を選択してください。',
            });
        }
        if (!row.discountedRequestSellingPrice) {
            errors.push({
                rowNumber: row.id,
                message: '売価を入力してください。',
            });
        }
        if (row.discountedRequestSellingPrice < 1) {
            errors.push({
                rowNumber: row.id,
                message: '売価は1以上の数値を入力してください。',
            });
        }
        if (!row.packingCategory) {
            errors.push({
                rowNumber: row.id,
                message: '販売方法・荷姿を選択してください。',
            });
        }
        if (!row.saleType) {
            errors.push({
                rowNumber: row.id,
                message: '特売種別・期間を選択してください。',
            });
        }
        const isFormatSalesStartDate = !/^\d{4}\/\d{2}\/\d{2}$/.test(row.salesStartDate);
        const isFormatSalesEndDate = !/^\d{4}\/\d{2}\/\d{2}$/.test(row.salesEndDate);
        if (!row.salesStartDate || isFormatSalesStartDate) {
            errors.push({
                rowNumber: row.id,
                message: '開始日を選択してください。',
            });
        }
        if (!row.salesEndDate || isFormatSalesEndDate) {
            errors.push({
                rowNumber: row.id,
                message: '終了日を選択してください。',
            });
        }
        if (isFormatSalesStartDate) {
            errors.push({
                rowNumber: row.id,
                message: '開始日は「yyyy/mm/dd」の形式で入力してください。',
            });
        }
        if (isFormatSalesEndDate) {
            errors.push({
                rowNumber: row.id,
                message: '終了日は「yyyy/mm/dd」の形式で入力してください。',
            });
        }
        if (!isFormatSalesStartDate && !isFormatSalesEndDate && row.salesStartDate > row.salesEndDate) {
            errors.push({
                rowNumber: row.id,
                message: '終了日は開始日以降を選択してください。',
            });
        }
        if (!isFormatSalesStartDate && !isFormatSalesEndDate && getDiffDays(row) > 31) {
            errors.push({
                rowNumber: row.id,
                message: '終了日は「開始日から31日以内」の日付を入力してください。',
            });
        }
    });

    if (errors.length > 0) {
        dispatch(
            setExcelValidation({
                isShow: true,
                items: errors,
            }),
        );
        return true;
    }

    return false;
};

export const getDiffDays = (formData) => {
    const startDate = new Date(formData.salesStartDate);
    const endDate = new Date(formData.salesEndDate);
    const diff = endDate.getTime() - startDate.getTime();
    return diff / (1000 * 60 * 60 * 24);
};

export const discountValidation = async (dispatch, items, isFreshness) => {
    for (const item of items) {
        if (item.discountedRequestSellingPrice === 0) {
            dispatch(setFiftyDiscount(true));
            return true;
        }

        const requestSellingPrice = await getSellingPrice(dispatch, item.discountedRequestSellingPrice, item.discountedCategory);
        const saratokuSellingPrice = item.saratokuSellingPrice;
        const edlpSellingPrice = item.edlpSellingPrice;

        const deviationRate = await getDeviationRate(requestSellingPrice, edlpSellingPrice, saratokuSellingPrice);

        item.deviationRate = deviationRate;
    }
    const thirtyDiscountItems = items.filter((item) => item.deviationRate > 30);
    const tenDiscountItems = items.filter((item) => item.deviationRate > 10);
    // 乖離判定（30%, 10%）
    if (thirtyDiscountItems.length > 0) {
        dispatch(
            setThirtyDiscount({
                isShow: true,
                items: thirtyDiscountItems,
            }),
        );
        return true;
    } else if (!isFreshness && tenDiscountItems.length > 0) {
        dispatch(
            setTenDiscount({
                isShow: true,
                items: tenDiscountItems,
            }),
        );
        return true;
    }
    return false;
};
